import type { DetailedHTMLProps, HTMLAttributes } from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import type { Theme } from '@emotion/react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled, { type StyledComponent } from '@emotion/styled';

import { token } from '@atlaskit/tokens';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
export const Container: StyledComponent<
	{
		as?: React.ElementType;
		theme?: Theme;
	} & {
		isSelected: boolean;
	},
	DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>,
	{}
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
> = styled.div<{ isSelected: boolean }>((props) => ({
	position: 'absolute',
	top: 0,
	right: 0,
	font: token('font.body.small'),
	fontWeight: token('font.weight.bold'),
	userSelect: 'none',
	borderBottomLeftRadius: '18px',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	padding: `${token('space.025')} ${token('space.100')} ${token('space.050')} ${token('space.150')}`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	color: props.isSelected ? token('color.text.inverse') : token('color.text.subtle', '#44546F'),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	backgroundColor: props.isSelected
		? token('color.border.selected', '#0C66E4')
		: token('color.border', 'rgba(9, 30, 66, 0.14)'),
	transition: 'color 0.1s ease-out 0s, background-color 0.1s ease-out 0s',
}));
